import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ASSET_MODELS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('ASSET_MODELS');
export const ASSET_MODELS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ASSET_MODELS_CRUD_ACTION_CONSTANTS
);
